var _line, _path, _rect, _path2, _path3, _line2, _line3, _rect2, _rect3, _path4, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleOutlineKiri(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 325,
    x2: 590,
    y2: 325,
    stroke: "#c7ccd1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 300 L90 262 Q90 244 106 240 L170 226 Q190 222 205 212 L250 168 Q258 160 270 160 L408 160 Q424 160 434 170 L482 214 Q492 224 506 226 L552 232 Q572 236 572 256 L572 300 Q572 308 564 308 L98 308 Q90 308 90 300 Z",
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 288,
    width: 460,
    height: 12,
    fill: "#1d4256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214 214 L254 172 Q258 168 266 168 L296 168 L296 214 Z",
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306 168 L410 168 Q418 168 424 176 L466 214 L306 214 Z",
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 301,
    y1: 214,
    x2: 301,
    y2: 300,
    stroke: "#204d63",
    strokeWidth: 1.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 412,
    y1: 214,
    x2: 412,
    y2: 300,
    stroke: "#204d63",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 232,
    width: 22,
    height: 5,
    rx: 2,
    fill: "#1d4256"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 232,
    width: 22,
    height: 5,
    rx: 2,
    fill: "#1d4256"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248 200 L234 204 L234 213 L248 213 Z",
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 248,
    width: 16,
    height: 20,
    rx: 4,
    fill: "#f6c945",
    stroke: "#a8791b",
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 244,
    width: 16,
    height: 22,
    rx: 4,
    fill: "#e57373",
    stroke: "#8b3a3a",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 294,
    r: 38,
    fill: "#1d4256"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 294,
    r: 38,
    fill: "#1d4256"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 294,
    r: 31,
    fill: "#2a2e33"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 294,
    r: 13,
    fill: "#8b9096"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 294,
    r: 31,
    fill: "#2a2e33"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 294,
    r: 13,
    fill: "#8b9096"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleOutlineKiri);
export default __webpack_public_path__ + "static/media/vehicle-outline-kiri.ec0cbc5f8d962fd9fc9be93741521e72.svg";
export { ForwardRef as ReactComponent };